import React, { useState } from 'react';
import { 
    Box,
    Button,
} from '@mui/material';
import PermissionGuard from '../../contexts/PermissionContext';
import ExpandedTextField from '../display/ExpandedTextField';



export default function AleConfigPopover(props){

    const {
        config,
        deleteConfig,
        handleChange
    } = props

    const [restrictCol, setRestrictCol] = useState(config?.args?.restrictCol || 0)
    const [restrictVal, setRestrictVal] = useState(config?.args?.restrictVal || 0)
    const [subclips, setSubclips] = useState(config?.args?.subclips || 0)

    const saveArgs = () => {
        handleChange({
            ...config,
            args: {
                ...config?.args,
                restrictCol: Number(restrictCol),
                restrictVal: Number(restrictVal),
                subclips: Number(subclips)
            }
        })
    }

    const validateNumber = (value) => {
        const nameRegex = /^\d+$/;
        return nameRegex.test(value)
    }

    return (
        <Box width={'275px'}>
            <ExpandedTextField
                label={'Column Length Restriction'}
                onChange={(e) => setRestrictCol(e.target.value)}
                value={restrictCol}
                error={validateNumber(restrictCol) ? false : true}
            />
            <ExpandedTextField
                label={'Data Length Restriction'}
                onChange={(e) => setRestrictVal(e.target.value)}
                value={restrictVal}
                error={validateNumber(restrictVal) ? false : true}
            />
            <ExpandedTextField
                label={'# of Subclip Channels'}
                onChange={(e) => setSubclips(e.target.value)}
                value={subclips}
                error={validateNumber(subclips) ? false : true}
            />
            <Box
                display={'flex'}
                justifyContent={'space-between'}
            >
                <PermissionGuard permission={['delete:deliverables']}>
                <Button
                    sx={{ color: 'red' }}
                    onClick={deleteConfig}
                >
                    Delete ALE
                </Button>
                </PermissionGuard>
                <Button
                    sx={{ color: 'white' }}
                    onClick={saveArgs}
                    disabled={
                        validateNumber(restrictCol)
                        && validateNumber(restrictVal)
                        && validateNumber(subclips)
                        ? false
                        : true
                    }
                >
                    Apply
                </Button>
            </Box>
        </Box>
    )
}